export default "__VITE_ASSET__tOLYr3VY__"